var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaystore = function SvgPlaystore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 39,
    viewBox: "0 0 131 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 38.849H5c-2.661 0-4.84-2.177-4.84-4.837V4.988C.16 2.328 2.34.151 5 .151h121c2.661 0 4.84 2.177 4.84 4.837v29.024c0 2.66-2.179 4.837-4.84 4.837Z",
    fill: "#363639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 .152H5C2.34.152.16 2.33.16 4.988v29.025c0 2.66 2.179 4.837 4.84 4.837h121c2.661 0 4.84-2.178 4.84-4.837V4.988c0-2.66-2.179-4.836-4.84-4.836Zm0 .773a4.07 4.07 0 0 1 4.065 4.063v29.025a4.072 4.072 0 0 1-4.066 4.063H5.001a4.07 4.07 0 0 1-4.066-4.063V4.988A4.07 4.07 0 0 1 5.001.925H126Z",
    fill: "#AC9F9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.06 10.062c0 .81-.24 1.456-.72 1.937-.547.572-1.259.859-2.134.859-.838 0-1.551-.29-2.137-.871-.588-.582-.88-1.301-.88-2.161 0-.86.292-1.58.88-2.16.586-.582 1.299-.872 2.137-.872.416 0 .814.08 1.192.243.378.163.681.379.909.649l-.511.51c-.385-.46-.914-.688-1.59-.688a2.21 2.21 0 0 0-1.586.644c-.446.43-.67.988-.67 1.674 0 .686.224 1.245.67 1.674.446.43.975.645 1.586.645.649 0 1.189-.216 1.623-.65.28-.28.443-.672.486-1.174h-2.109v-.698h2.814c.027.152.04.297.04.439Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.06 10.062h-.096c0 .792-.232 1.406-.693 1.869h-.001v.002c-.53.552-1.209.827-2.064.828-.816-.001-1.5-.279-2.07-.843-.568-.565-.85-1.255-.85-2.092 0-.838.282-1.527.85-2.092.57-.564 1.254-.843 2.07-.844.403 0 .787.079 1.154.236a2.3 2.3 0 0 1 .872.622l.075-.062-.069-.07-.51.512.068.068.074-.062c-.402-.482-.967-.725-1.664-.723a2.303 2.303 0 0 0-1.653.671c-.467.448-.7 1.037-.699 1.744 0 .707.232 1.296.699 1.744a2.3 2.3 0 0 0 1.653.671c.67.001 1.241-.226 1.69-.676.3-.3.47-.718.515-1.236l.01-.105h-2.118V9.72h2.717v-.097l-.095.018c.026.146.04.285.04.42h.193c0-.146-.014-.298-.043-.455l-.013-.08h-2.993v.892h2.206v-.097l-.096-.009c-.043.487-.198.853-.46 1.116-.415.414-.925.619-1.553.62a2.109 2.109 0 0 1-1.518-.617c-.427-.413-.64-.939-.64-1.605s.213-1.192.64-1.604c.43-.415.929-.617 1.518-.618.655.001 1.148.218 1.516.654l.068.082.585-.586.062-.063-.057-.067a2.494 2.494 0 0 0-.943-.676 3.096 3.096 0 0 0-1.23-.251 3.022 3.022 0 0 0-2.207.9c-.604.597-.909 1.347-.908 2.229 0 .88.304 1.632.908 2.23.602.597 1.346.9 2.206.898.896.001 1.64-.296 2.203-.888L45.34 12l.07.068c.5-.5.75-1.177.749-2.005h-.097l-.002-.001Zm4.462-2.425h-2.644v1.84h2.385v.698h-2.385v1.84h2.644v.713h-3.391V6.923h3.391v.714Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.522 7.637V7.54h-2.741v2.034h2.385v.504h-2.385v2.034h2.645v.519h-3.198V7.02h3.198v.617h.096V7.54v.097h.097v-.81h-3.584v5.998h3.584v-.907h-2.644v-1.646h2.385v-.891h-2.385V7.734h2.644v-.097h-.097Zm3.147 5.091h-.746V7.637h-1.622v-.714h3.991v.714h-1.623v5.091Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.669 12.728v-.097h-.649V7.54h-1.623v-.52h3.798v.52h-1.623v5.188h.097v-.097.097h.097V7.734h1.622v-.907h-4.184v.907h1.622v5.091h.94v-.097h-.097Zm4.511-5.805h.745v5.805h-.745V6.923Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.18 12.728h.097V7.02h.552v5.611h-.649v.097h.097-.097v.097h.842V6.827h-.939v5.998h.097v-.097Zm4.056 0h-.747V7.637h-1.622v-.714h3.991v.714h-1.622v5.091Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.236 12.728v-.097h-.651V7.54h-1.621v-.52h3.797v.52h-1.622v5.188h.097v-.097.097h.097V7.734h1.622v-.907H59.77v.907h1.622v5.09h.941v-.096h-.097Zm5.47-1.236c.43.435.955.653 1.578.653.621 0 1.148-.218 1.578-.653.43-.435.645-.99.645-1.666 0-.676-.216-1.231-.645-1.666a2.136 2.136 0 0 0-1.578-.652c-.623 0-1.148.217-1.578.652-.43.435-.645.99-.645 1.666 0 .676.215 1.23.645 1.666Zm3.707.486c-.57.587-1.28.88-2.13.88-.848 0-1.559-.293-2.128-.88-.57-.586-.855-1.304-.855-2.152 0-.85.284-1.566.855-2.152.57-.587 1.28-.88 2.129-.88.844 0 1.552.295 2.126.884.573.589.86 1.305.86 2.148 0 .848-.286 1.566-.857 2.152Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m67.706 11.492-.069.068a2.23 2.23 0 0 0 1.647.681 2.229 2.229 0 0 0 1.646-.68c.449-.454.675-1.039.674-1.735.001-.696-.225-1.281-.674-1.734a2.23 2.23 0 0 0-1.646-.681 2.23 2.23 0 0 0-1.647.68c-.448.454-.673 1.039-.672 1.735-.001.696.224 1.281.672 1.734l.069-.068.069-.068c-.41-.417-.616-.942-.617-1.598.001-.655.206-1.18.617-1.599v.001a2.033 2.033 0 0 1 1.509-.624 2.034 2.034 0 0 1 1.508.623v.001c.412.417.618.943.619 1.598-.001.656-.207 1.18-.619 1.598a2.031 2.031 0 0 1-1.508.624 2.033 2.033 0 0 1-1.51-.624l-.068.068Zm3.707.486-.07-.068c-.554.57-1.232.85-2.06.85-.826 0-1.505-.28-2.059-.85l-.003-.002.003.002c-.554-.57-.827-1.257-.828-2.084.001-.827.274-1.514.828-2.084.554-.57 1.233-.85 2.06-.852.822.001 1.498.284 2.056.856.556.572.831 1.258.832 2.08 0 .827-.276 1.515-.828 2.084l.14.136c.586-.603.883-1.35.882-2.22 0-.865-.297-1.61-.887-2.216-.59-.606-1.329-.914-2.195-.913-.871-.001-1.613.305-2.198.91-.589.602-.884 1.349-.883 2.219-.001.87.294 1.617.883 2.22l.002.003-.002-.003c.585.605 1.327.91 2.198.908.871.001 1.612-.303 2.2-.908l-.07-.068h-.001Zm1.903.75V6.923h.908l2.823 4.516h.032l-.032-1.118V6.923h.747v5.805h-.779l-2.953-4.734h-.032l.032 1.119v3.615h-.746Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.316 12.728h.097V7.02h.758l2.823 4.516h.185l-.035-1.217V7.02h.554v5.611h-.629l-2.953-4.734h-.186l.035 1.218v3.516h-.649v.097h.097-.097v.097h.843V9.112l-.032-1.121-.097.003v.097h.032v-.097l-.082.051 2.982 4.78h.929V6.827h-.941v3.495l.032 1.12.097-.003v-.096h-.032v.096l.082-.051-2.85-4.561H73.22v5.998h.096v-.097Zm30.358 16.447h1.806V17.08h-1.806v12.095Zm16.269-7.738-2.071 5.243h-.062l-2.149-5.243h-1.946l3.223 7.33-1.837 4.075h1.884l4.966-11.405h-2.008ZM109.699 27.8c-.592 0-1.417-.295-1.417-1.027 0-.933 1.028-1.291 1.915-1.291.795 0 1.167.17 1.65.404a2.19 2.19 0 0 1-2.148 1.914Zm.218-6.628c-1.308 0-2.662.575-3.222 1.851l1.603.67c.342-.67.98-.887 1.65-.887.934 0 1.884.56 1.9 1.555v.125c-.328-.187-1.028-.467-1.884-.467-1.728 0-3.488.949-3.488 2.723 0 1.618 1.417 2.66 3.005 2.66 1.214 0 1.883-.544 2.304-1.182h.062v.934h1.744v-4.637c0-2.148-1.603-3.345-3.674-3.345Zm-11.163 1.736h-2.569v-4.145h2.57c1.35 0 2.116 1.117 2.116 2.073 0 .937-.766 2.072-2.117 2.072Zm-.046-5.829H94.38v12.095h1.805v-4.582h2.523c2.002 0 3.97-1.449 3.97-3.756 0-2.308-1.968-3.757-3.97-3.757ZM75.106 27.804c-1.246 0-2.292-1.045-2.292-2.479 0-1.45 1.046-2.509 2.292-2.509 1.233 0 2.2 1.06 2.2 2.509 0 1.434-.967 2.479-2.2 2.479Zm2.075-5.689h-.062c-.406-.484-1.186-.92-2.169-.92-2.057 0-3.945 1.808-3.945 4.13 0 2.307 1.888 4.099 3.945 4.099.983 0 1.763-.436 2.169-.935h.062v.593c0 1.574-.842 2.415-2.2 2.415-1.106 0-1.792-.795-2.073-1.464l-1.575.654c.452 1.09 1.652 2.432 3.648 2.432 2.122 0 3.915-1.247 3.915-4.287v-7.387h-1.715v.67Zm2.963 7.06h1.809V17.08h-1.81v12.095h.001Zm4.476-3.99c-.048-1.59 1.232-2.4 2.152-2.4.718 0 1.326.358 1.528.873l-3.68 1.527Zm5.614-1.371c-.343-.92-1.388-2.619-3.524-2.619-2.121 0-3.884 1.668-3.884 4.114 0 2.308 1.746 4.115 4.086 4.115 1.887 0 2.98-1.153 3.431-1.824l-1.403-.934c-.468.686-1.108 1.138-2.028 1.138-.92 0-1.575-.421-1.996-1.247l5.505-2.276-.187-.467Zm-43.859-1.357v1.746h4.18c-.125.982-.452 1.699-.951 2.198-.608.607-1.56 1.278-3.229 1.278-2.572 0-4.584-2.073-4.584-4.645 0-2.571 2.012-4.645 4.584-4.645 1.389 0 2.402.546 3.151 1.247l1.232-1.231c-1.045-.998-2.433-1.76-4.383-1.76-3.524 0-6.487 2.867-6.487 6.39 0 3.522 2.963 6.389 6.487 6.389 1.904 0 3.338-.623 4.461-1.792 1.154-1.154 1.513-2.774 1.513-4.083 0-.406-.032-.78-.094-1.092h-5.88ZM57.1 27.804c-1.248 0-2.323-1.029-2.323-2.495 0-1.48 1.075-2.493 2.323-2.493s2.323 1.013 2.323 2.493c0 1.466-1.075 2.495-2.323 2.495Zm0-6.609c-2.277 0-4.133 1.73-4.133 4.114 0 2.37 1.856 4.115 4.133 4.115s4.132-1.745 4.132-4.115c0-2.384-1.855-4.114-4.132-4.114Zm9.015 6.609c-1.247 0-2.323-1.029-2.323-2.495 0-1.48 1.076-2.493 2.323-2.493 1.247 0 2.324 1.013 2.324 2.493 0 1.466-1.077 2.495-2.324 2.495Zm0-6.609c-2.277 0-4.133 1.73-4.133 4.114 0 2.37 1.856 4.115 4.133 4.115s4.133-1.745 4.133-4.115c0-2.384-1.856-4.114-4.133-4.114Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.333 31.487-.071-.07c-.282-.297-.448-.76-.448-1.358v.14V8.798v.147c0-.648.194-1.138.518-1.43l11.994 11.986-11.993 11.986ZM9.818 8.639v-.002.002Zm0-.007V8.63v.002Z",
    fill: "url(#Playstore_svg__a)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.323 23.64.09-.053 4.737-2.689c.452-.256.753-.567.903-.897-.15.33-.451.64-.903.898l-4.736 2.69-.091.05v.001Zm0-.143-3.997-3.996 3.998-3.996 4.826 2.741c.614.348.957.796 1.014 1.255v.002c-.057.457-.4.905-1.014 1.254l-4.826 2.74h-.001Z",
    fill: "url(#Playstore_svg__b)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.188 31.943c-.335 0-.626-.11-.855-.314v-.001c.235.21.54.322.855.315Zm.001-.142a1.242 1.242 0 0 1-.856-.314L22.326 19.5l3.998 3.996-14.05 7.98c-.389.22-.758.324-1.085.324v.001Zm-.858-.175a1.25 1.25 0 0 1-.063-.061l.063.06v.001Z",
    fill: "url(#Playstore_svg__c)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.326 19.501 10.332 7.515a1.25 1.25 0 0 1 .855-.314c.328 0 .697.104 1.086.326l14.05 7.978-3.997 3.996Zm4.088-4.086-14.14-8.03c-.39-.22-.759-.325-1.087-.325h-.004.005c.328 0 .696.104 1.085.325l14.14 8.03h.001Z",
    fill: "url(#Playstore_svg__d)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.278 31.94c.304-.017.641-.122.995-.322l14.05-7.978-14.05 7.978c-.354.201-.69.306-.995.322Zm-.945-.311-.002-.003.002.003Zm-.065-.064-.006-.006.006.006Z",
    fill: "#363639"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.323 23.645.1-.058-.1.058Z",
    fill: "url(#Playstore_svg__e)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.19 31.943c-.336 0-.628-.11-.857-.315l-.002-.002-.063-.061-.006-.006.071-.072c.229.206.521.315.856.314.327 0 .696-.103 1.084-.324l14.05-7.98.09.09-.09.053-14.05 7.978c-.354.2-.69.305-.995.322l-.089.003h.001Z",
    fill: "url(#Playstore_svg__f)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.308 31.56c-.31-.299-.494-.761-.494-1.36v-.001c0 .6.183 1.062.494 1.36v.001Z",
    fill: "#363639"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.262 31.558c-.282-.297-.448-.76-.448-1.36v-.14c0 .6.166 1.062.448 1.36l.071.069-.071.071Z",
    fill: "url(#Playstore_svg__g)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.262 31.567.079-.08-.079.08Z",
    fill: "url(#Playstore_svg__h)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.053 20.002c.082-.163.123-.331.123-.5h.001c0 .169-.042.336-.124.5Z",
    fill: "#363639"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.414 23.587-.09-.09 4.826-2.74c.614-.349.957-.797 1.014-1.254 0 .167-.036.336-.11.498-.15.33-.452.64-.904.897l-4.736 2.69Z",
    fill: "url(#Playstore_svg__i)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.165 19.501c0-.506-.338-1.012-1.015-1.396l-4.736-2.69 4.736 2.69c.677.384 1.015.89 1.015 1.396Z",
    fill: "#645856"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.164 19.501c-.057-.459-.4-.907-1.014-1.255l-4.826-2.74.09-.09 4.736 2.689c.677.384 1.014.89 1.014 1.396Z",
    fill: "url(#Playstore_svg__j)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m9.817 8.641.001-.002v.002h-.001Zm.001-.004v-.005.005Zm0-.006c.057-.994.597-1.567 1.361-1.57-.33.001-.62.11-.846.313l-.002.003a1.461 1.461 0 0 0-.07.067c-.253.27-.414.671-.443 1.187Z",
    fill: "#645856"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.814 8.945v-.147c0-.054.002-.106.003-.157l.001-.002V8.63c.03-.516.19-.918.444-1.187l.07.071c-.324.292-.518.782-.518 1.43v.001Zm.517-1.568.002-.003-.002.003Z",
    fill: "url(#Playstore_svg__k)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.324 15.505-14.05-7.978c-.39-.222-.759-.326-1.087-.326-.335 0-.626.11-.855.314l-.07-.07a1.245 1.245 0 0 1 .917-.384h.008c.328 0 .697.103 1.086.325l14.14 8.03-.09.09h.001Z",
    fill: "url(#Playstore_svg__l)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__a",
    x1: 21.263,
    y1: 8.577,
    x2: 2.023,
    y2: 3.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0081C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009FE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__b",
    x1: 32.912,
    y1: 19.501,
    x2: 9.491,
    y2: 19.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__c",
    x1: 24.194,
    y1: 21.721,
    x2: 8.628,
    y2: -4.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1614B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C33956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__d",
    x1: 7.224,
    y1: 0.322,
    x2: 14.154,
    y2: -11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__e",
    x1: 27.004,
    y1: 23.342,
    x2: 24.584,
    y2: 23.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3AD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF892C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__f",
    x1: 24.193,
    y1: 21.721,
    x2: 17.054,
    y2: -4.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A93950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__g",
    x1: 15.953,
    y1: 8.57,
    x2: 4.203,
    y2: 5.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__h",
    x1: 11.399,
    y1: 30.68,
    x2: 9.578,
    y2: 28.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B23853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__i",
    x1: 32.912,
    y1: 19.502,
    x2: 9.493,
    y2: 19.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BD21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF9527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__j",
    x1: 32.912,
    y1: 19.501,
    x2: 9.493,
    y2: 19.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE25E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__k",
    x1: 15.953,
    y1: 8.577,
    x2: 4.417,
    y2: 6.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2396D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Playstore_svg__l",
    x1: 7.225,
    y1: 0.322,
    x2: 10.413,
    y2: -11.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#709C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13B3A9"
  })))));
};
export default SvgPlaystore;